import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { LoggerService } from 'app/logger/logger.service';
// global const
const MOBILE_NO_REGEX = /^\d{10}$/;
// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  // public variables define
  username: string;
  is_validate: boolean;
  public userNameForm;

  constructor(private fb: FormBuilder, private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private authService: AuthService, private logger:LoggerService,
    private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {
    this.userNameForm = fb.group({
      mobilePhoneFormControl: ['', Validators.required]
    }, { validator: UserNameValidation.UserNameValidate });
    this.sharedService.setHeaderTitle('default_page');
    const that = this.sharedService;
    setTimeout(function () {
      that.setHeaderErrorMessage('forget_password', false, 'notification error', '');
      that.setHeaderTitle('forget_password');
    }, 10);
  }


  ngOnInit() {
  }

  validate(event: any) {
    this.sharedService.setHeaderErrorMessage('forget_password', false, 'notification error', '');
    if (this.username !== '' && (this.username.match(MOBILE_NO_REGEX) || this.username.match(EMAIL_REGEX))) {
      this.is_validate = true;
      if (event.keyCode === 13) {
        document.getElementById('btn-click').click();
      }
    } else {
      this.is_validate = false;
    }
  }
  // password reset
  resetPassword() {
    this.sharedService.setHeaderErrorMessage('forget_password', false, 'notification error', '');
    let methodName = this.constructor.name+'.verifyToken';
    this.authService.resetPassword({ 'username': this.username })
      .then(res => {
        let logObj = {
          method: methodName,
          request: this.username,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        if (res.result.status === 'success') {
          // window.open(res.url, '_blank');
          if (this.username.length == 10 && this.username.match(MOBILE_NO_REGEX)) {
            this.dialog.open(ChangePasswordSuccessLink);
          } else {
            this.dialog.open(ChangePasswordSuccessLinkEmail);
            // this.sharedService.setHeaderErrorMessage('forget_password', true, 'notification error', res.message);
          }

        } else {
          window.scrollTo(0, 0);
          this.sharedService.setHeaderErrorMessage('forget_password', true, 'notification error', res.message);
        }
      }, (error)=>{
        let logObj = {
          method: methodName,
          request: this.username,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex)=>{
        let logObj = {
          method: methodName,
          request: this.username,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }
}
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-password-success',
  // tslint:disable-next-line:max-line-length
  template: `<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"></button><div class="dialog-info"><p>A link to reset your password will be sent to your mobile phone.</p></div></div><div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="successOk()">Ok</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ChangePasswordSuccessLink {
  // tslint:disable-next-line:max-line-length
  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService, private authService: AuthService, private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {

  }

  successOk() {
    this.router.navigate(['./sign-in']);
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-password-success-email',
  // tslint:disable-next-line:max-line-length
  template: `<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"></button><div class="dialog-info"><p>A link to reset your password will be sent to your email address.</p></div></div><div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="successOk()">Ok</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ChangePasswordSuccessLinkEmail {
  // tslint:disable-next-line:max-line-length
  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService, private authService: AuthService, private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {

  }

  successOk() {
    this.router.navigate(['./sign-in']);
  }
}

export class UserNameValidation {
  static UserNameValidate(AC: AbstractControl) {
    const username = AC.get('mobilePhoneFormControl').value; // to get value in input tag
    if (username !== '' && username !== undefined && !username.match(MOBILE_NO_REGEX) && !username.match(EMAIL_REGEX)) {
      AC.get('mobilePhoneFormControl').setErrors({ UserNameValidate: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forget-password/forget-password.component.ts